import { useEffect } from 'react';

const SITE_URL = (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://rwa99.cn';

export default function CasesSEOHead() {
  useEffect(() => {
    document.title = 'RWA99 案例深度库 | 全球87个RWA真实世界资产代币化案例解析';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    setMeta('description', 'RWA99案例深度库 — 全球87个真实世界资产代币化案例完整解析，覆盖债券、房地产、大宗商品、股权、碳信用、供应链信贷7大赛道，含智能合约源码、法律结构及合规路径，持续更新。');
    setMeta('keywords', 'RWA案例,真实世界资产案例,区块链代币化案例,RWA债券,房地产RWA,碳信用代币化,RWA智能合约,RWA合规,香港RWA,OUSG,Centrifuge,RWA99');
    setMeta('robots', 'index, follow');
    setMeta('og:title', 'RWA99 案例深度库 | 全球87个RWA案例完整解析', true);
    setMeta('og:description', '7大资产赛道，87个案例，含智能合约源码与合规路径。债券/房地产/大宗商品/股权/碳信用/供应链信贷全覆盖。', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', `${SITE_URL}/cases`, true);
    setMeta('og:site_name', 'RWA99.cn', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'RWA99 案例深度库 | 全球87个RWA案例完整解析');
    setMeta('twitter:description', '7大资产赛道，87个案例，含智能合约源码与合规路径，持续更新。');

    const existing = document.querySelectorAll('script[data-cases-jsonld]');
    existing.forEach((el) => el.remove());

    const TRACK_COUNTS = [
      { name: '债券类RWA', count: 18 },
      { name: '房地产RWA', count: 15 },
      { name: '大宗商品RWA', count: 12 },
      { name: '股权代币化', count: 10 },
      { name: '碳信用代币化', count: 14 },
      { name: '供应链信贷RWA', count: 10 },
      { name: '其他RWA资产', count: 8 },
    ];

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${SITE_URL}/cases#webpage`,
        url: `${SITE_URL}/cases`,
        name: 'RWA99 案例深度库 | 全球87个RWA真实世界资产代币化案例解析',
        description: 'RWA99案例深度库 — 全球87个真实世界资产代币化案例完整解析，覆盖7大赛道，含智能合约源码、法律结构及合规路径。',
        inLanguage: 'zh-CN',
        isPartOf: { '@id': `${SITE_URL}/#website` },
        publisher: { '@id': `${SITE_URL}/#organization` },
        datePublished: '2026-01-01',
        dateModified: '2026-03-30',
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: SITE_URL },
            { '@type': 'ListItem', position: 2, name: '案例深度库', item: `${SITE_URL}/cases` },
          ],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        '@id': `${SITE_URL}/cases#collection`,
        url: `${SITE_URL}/cases`,
        name: 'RWA99 全球RWA案例深度库',
        description: '全球87个真实世界资产代币化标杆案例，7大赛道全覆盖，含智能合约源码与合规路径分析。',
        inLanguage: 'zh-CN',
        publisher: { '@id': `${SITE_URL}/#organization` },
        numberOfItems: 87,
        keywords: ['RWA案例', '债券代币化', '房地产代币化', '碳信用代币化', '智能合约', '合规路径'],
        about: TRACK_COUNTS.map((t) => ({
          '@type': 'Thing',
          name: t.name,
          description: `${t.count}个${t.name}案例`,
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'RWA99案例库收录了哪些类型的资产？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'RWA99案例库覆盖7大资产赛道：债券（18个）、房地产（15个）、大宗商品（12个）、股权（10个）、碳信用（14个）、供应链信贷（10个）及其他（8个），共87个全球标杆案例，包括美国、欧盟、香港、新加坡等主要市场。',
            },
          },
          {
            '@type': 'Question',
            name: '案例库是否包含智能合约源码？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '是的，案例库中部分重点案例（如OUSG、Centrifuge DROP Token、RealT、PAXG、Toucan BCT等）提供完整注释版Solidity智能合约源码，并提供Etherscan链上验证地址，方便技术人员学习参考。',
            },
          },
          {
            '@type': 'Question',
            name: '这些RWA案例适合中国企业参考吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '非常适合。这些案例涵盖了香港、新加坡等合规管辖区的RWA发行实践，以及对应的监管框架、代币标准与法律结构，对计划通过香港持牌VATP进行RWA发行的中国企业具有重要参考价值。',
            },
          },
        ],
      },
    ];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-cases-jsonld', 'true');
      script.textContent = JSON.stringify(schema, null, 2);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-cases-jsonld]').forEach((el) => el.remove());
    };
  }, []);

  return null;
}
